import { capitalize } from "../../helpers/string/capitalize";
import { FullRole, RoleTitle, RoleToDescription } from "./types";
import { UserRole } from "../types";

const userRoleTitles: Record<string, string> = {
  Admin: "Admin",
  "Global Owner": "Global Owner",
  "Global Editor": "Global Editor",
  "Global Viewer": "Global Viewer",
  companyOwner: "Company Owner",
  companyEditor: "Company Editor",
  companyViewer: "Company Viewer",
};

export const roleDescriptionsMapping = {
  admin: "unlimited access to the system",
  "global owner": "global access to the system",
  "global editor": "edit global data",
  "global viewer": "view global data",
  "company owner": "full access to company data",
  "company editor": "edit company data",
  "company viewer": "view company data",
};

export const companyUserRoles: RoleTitle[] = [
  {
    kind: "company",
    role: "editor",
  },
  {
    kind: "company",
    role: "owner",
  },
  {
    kind: "company",
    role: "viewer",
  },
];

export const globalUserRoles: RoleTitle[] = [
  {
    kind: "admin",
    role: "admin",
  },
  {
    kind: "global",
    role: "owner",
  },
  {
    kind: "global",
    role: "editor",
  },
  {
    kind: "global",
    role: "viewer",
  },
];

export const globalRolesMapping: { [key: string]: FullRole } = {
  Admin: "admin",
  "Global Viewer": "viewer",
  "Global Editor": "editor",
  "Global Owner": "owner",
};

export const getUserRoleTitle = (userRole: UserRole): string =>
  userRoleTitles[userRole];

export const getRoleDescription = (roleName: RoleToDescription): string =>
  roleDescriptionsMapping[roleName] ?? "No description";

export const mapGeneralRoleTitleToUserRoleTitle = ({
  kind,
  role,
}: RoleTitle): string => {
  return kind === "admin"
    ? capitalize(kind)
    : `${capitalize(kind)} ${capitalize(role)}`;
};

export const parseRoleName = ({ kind, role }: RoleTitle): string => {
  if (kind === "admin") return `${kind}`;
  if (!role) return "Unconsistent role";
  return `${kind} ${role}`;
};
